import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { HabilitacaoAlternativa } from "src/app/model/habilitacao-alternativa.model";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";


export interface NovaHabilitacao {
  dataInicio: Date;
  dataMaximaValidade: Date;
  valorLimite: number;
}

@Injectable({
  providedIn: 'root'
})
export class HabilitacaoService extends FgiBackEndService<HabilitacaoAlternativa>{

  getNewEntity(): HabilitacaoAlternativa {
    const model = new HabilitacaoAlternativa();
    model.dataRegistro = new Date();
    return model;
  }

  protected getResourceURL(): string {
    return 'front/habilitacao-alternativa';
  }

  obterAgentesDisponiveis(): Observable<AgenteFinanceiro[]> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/agentes`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<AgenteFinanceiro[]>;
  }

  carregarAgente(idAgente: number): Observable<AgenteFinanceiro> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/agente/${idAgente}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<AgenteFinanceiro>;
  }

  obterPorAgente(idAgente: number): Observable<HabilitacaoAlternativa[]> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/agentes/${idAgente}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<HabilitacaoAlternativa[]>;
  }

  salvar(agenteFinanceiroId: number, novaHabilitacao: NovaHabilitacao[]): Observable<any> {
    const options = blockUi();
    const body = {
      agenteFinanceiroId,
      habilitacoes: novaHabilitacao,
    };
    return this.http.post(`${this.BASE_URL}`, body, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  editar(habilitacao: HabilitacaoAlternativa): Observable<any> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/editar`, habilitacao, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  suspender(idAgente: number, justificativa: string): Observable<any> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/suspender`, {idAgente: idAgente, justificativa: justificativa}, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  getHabilitacoes(params?: any): any{
    return this.http.get(`${this.BASE_URL}/`, {params: params}).pipe(
      catchError((e) => this.handleError(e))
    ) as Observable<Array<HabilitacaoAlternativa>>;
  }

  excluir(id: number): any{
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}`, options).pipe(
      catchError((e) => this.handleError(e))
    ) as Observable<Array<HabilitacaoAlternativa>>;
  }

}
